// Global ref for the navbar's "Estudos" picker modal (RegistryIndicatorsDropdown).
// Same pattern as symbolSpotlightRef / activeIndicatorsModalRef — lets the
// chart context menu open the existing picker without prop drilling. The
// context menu focuses the clicked chart BEFORE opening, so the picker's
// getSelectedChart() resolves to the right target.
export const indicatorsPickerRef = { current: null };
